/**
 * How each setting works: Support & programmes: the seed credit programme.
 *
 * One entry per setting, keyed by a camelCase topic that is unique across
 * every file in this folder (settingsHelp.test.js checks). `title` is the
 * setting's label as the editor shows it; `body` says what the setting is,
 * how the server uses it, what it does NOT do, and which other setting it
 * works with. Every fact is one the code enforces; a setting that is stored
 * but drives nothing yet says so. Read the rules in ../settingsHelp.js.
 */
export const SEED_CREDITS_HELP = Object.freeze({
  seedCreditProgramme: {
    title: "Seed credits",
    body: "Seed Credit is a balance Lusuku pays, in shillings, to a customer who submits a new vendor through the app (a seeder) once operations approves the submission. It is earned on approval only, never on submission. Earned credit shows on the seeder's balance; no checkout spends it yet, so today it is a recognition balance rather than money off an order.",
  },
  seedVendorReward: {
    title: "Reward for an approved vendor",
    body: "A seeder whose vendor is approved is granted free delivery on their own orders from that vendor for life, at most one order a day, instead of a shilling amount. The grant is recorded automatically at approval and has no amount to set here, but no checkout applies it yet, so the delivery fee is still charged today. The old shilling vendor reward was retired in April 2026 and is no longer paid.",
  },
  seedProductReward: {
    title: "Reward per approved product",
    body: "Paid into the seeder's Seed Credit balance for each product in their submission that passes quality control, at the moment operations approves the submission. Products that fail quality control earn nothing. A change applies to the next approval; credit already paid is not recalculated.",
  },
  seedMilestoneBonus: {
    title: "Bonus for every 10 vendors in 30 days",
    body: "Paid once on the approval that brings the seeder's approved submissions in the last 30 days to 10, and again at 20, 30 and so on. The 30 days roll with each approval, so the count drops as older approvals age out. It is paid on top of the product reward.",
  },
  seedPerOrderCap: {
    title: "Most credit one order can use",
    body: "The largest amount of Seed Credit a customer may put towards one order's delivery fee; a larger request is refused. It is not a cap on delivery fees, which the delivery fee engine sets, and not a minimum order value. No checkout in the apps or on the web spends Seed Credit yet, so this limit changes no order today; it applies once credit can be spent at checkout.",
  },
  seedConfigSource: {
    title: "Where these amounts come from",
    body: "Until someone saves on this page, the server uses its shipped defaults, or the values set in the hosting environment when there are any. The first save stores all three amounts in the database, and from then on the saved amounts win. A save takes effect on the next approval without a restart.",
  },
});
